e4.scrollReveal = {
    init: function () {
        var arrObservables = jQuery( '.js-e-animation' ).toArray();
        if ( e4.util.observer.isSupported === true && arrObservables.length > 0 ) {
            e4.util.observer.bind( arrObservables, e4.scrollReveal.bindObserver );
        }
    },
    bindObserver: function ( objEntry, objObserver ) {
        if ( objEntry.isIntersecting === true ) {
            e4.scrollReveal.reveal( objEntry.target );
            objObserver.unobserve( objEntry.target );
        } else {
            e4.scrollReveal.conceal( objEntry.target );
        }

    },
    conceal: function ( domElm ) {
        var jThis = jQuery( domElm );
        jThis.addClass( 'e-animation-conceal' );
    },
    reveal: function ( domElm ) {
        var jThis = jQuery( domElm );
        jThis.removeClass( 'e-animation-conceal' );
    }
};
